/**
 * Visible words of the order surfaces (DOM ladder, order pad, chart order bar, top-bar Flatten;
 * owner 2026-10-04): exit buttons name their scope, and an empty area says its state in one line.
 * The full meaning of each exit stays in its tooltip and accessible name (SPEC §9.7 semantics);
 * hotkeys are unchanged. Pure.
 */

/** The product root of a contract ("NQZ6" → "NQ", "6EH7" → "6E"); a root comes back as is (as core `symbolRoot`). */
function rootOf(contract: string): string {
  const s = contract.trim().toUpperCase();
  const m = /^([A-Z0-9]+?)[FGHJKMNQUVXZ]\d{1,2}$/.exec(s);
  return m?.[1] ?? s;
}

/** "Close NQ": closes this contract's position and cancels its orders (Exit at Mkt & Cxl). */
export function closeLabel(contract: string | null): string {
  return contract ? `Close ${rootOf(contract)}` : "Close";
}

/** The account flatten, or — while "All accounts" is selected — every account's. */
export function flattenLabel(allAccounts: boolean): "Exit all accts" | "Exit all" {
  // Owner 2026-10-06: "close/exit all" — it closes every position and cancels every order.
  return allAccounts ? "Exit all accts" : "Exit all";
}

/** Cancels every working order on the account; "Cxl all" only where "Cancel all" would wrap. */
export const CANCEL_ALL_LABEL = "Cancel all";
export const CANCEL_ALL_COMPACT_LABEL = "Cxl all";
export const REVERSE_LABEL = "Reverse";

/** Market-data state of a surface's empty area, one line (owner 2026-10-04). */
export type MdStateInput = {
  /** The hub's connection: "off" (signed out), "connecting", "connected", "disconnected". */
  status: "off" | "connecting" | "connected" | "disconnected";
  /** The gateway's refusal for this symbol (subscription refused, unknown contract…), if any. */
  notice: string | null;
};

export const NO_DATA_YET = "No data yet.";
export const MD_RECONNECTING = "Rithmic disconnected — reconnecting.";

/** "No data yet." / "Rithmic disconnected — reconnecting." / "Rejected: {reason}." */
export function mdStateLine(s: MdStateInput): string {
  const reason = s.notice?.trim().replace(/[.\s]+$/, "") ?? "";
  if (reason !== "") return `Rejected: ${reason}.`;
  if (s.status === "disconnected") return MD_RECONNECTING;
  return NO_DATA_YET;
}

/** The position line of an entry surface when there is none. */
export const FLAT = "Flat.";
